import { ArrowRightIcon } from "@radix-ui/react-icons";
import { Box, Button, Flex, Image, Text } from "components/Base";
import DownloadLogo from "global/MainLayout/DownloadLogo";
import info from "lib/api/info";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

function BannerHome() {
  const navigate = useNavigate();

  const [about, setAbout] = useState("");

  useEffect(() => {
    info
      .getAbout()
      .then((res) => setAbout(res.data.value))
      .catch(() => {});
  }, []);

  const handleClick = () => {
    navigate("/login");
  };

  return (
    <Flex bgColor="$secondary5" py="95px" mt="64px">
      <Flex
        w="100%"
        maxWidth="1196px"
        m="0 auto"
        alignItems="center"
        justify="space-between"
      >
        <Flex direction="column" css={{ flex: 1 }}>
          <Text
            as="h1"
            weight="$bold"
            fontSize="$5xl"
            lineHeight="60px"
            color="$secondary"
            mb="20px"
          >
            SIGAP - Inspirasi Desa
          </Text>
          <Box
            css={{
              display: "-webkit-box",
              "-webkit-line-clamp": 3,
              "-webkit-box-orient": "vertical",
              overflow: "hidden",
            }}
          >
            <Text as="h2" fontSize="$2xl" lineHeight="34px" mb="32px">
              {about || "akSi Inspiratif warGA untuk Perubahan"}
            </Text>
          </Box>
          <Button
            color="secondary"
            css={{
              "&.ant-btn": {
                p: "10px 32px",
                br: "$rounded-full",
                fontWeight: "$bold",
              },
            }}
            mb="32px"
            onClick={handleClick}
          >
            <Text as="span" fontSize="$md" color="inherit">
              Ketahui Lebih Lanjut
            </Text>
            <span style={{ marginLeft: 10 }}>
              <ArrowRightIcon />
            </span>
          </Button>
          <Text
            fontSize="$xl"
            lineHeight="24px"
            weight="$bold"
            mt="32px"
            mb="12px"
          >
            Download Aplikasi di
          </Text>
          <Flex gap="24px" align="center">
            <DownloadLogo />
          </Flex>
        </Flex>
        <Image src="/images/banner.png" height="402px" />
      </Flex>
    </Flex>
  );
}

export default BannerHome;
